module.exports = __webpack_public_path__ + "static/media/pinBRed.20bf45a0.svg";